@for(type of types; track type) {
<div class="link-group">
  <div class="links-group-title">{{ 'label.links_'+type.value | translate }}</div>

  @for(row of linksRows; track row) {

  @if(getFormControlByGroupRowAndControlName(type.value, row, 'title').value &&
  getFormControlByGroupRowAndControlName(type.value, row, 'url').value && !editMode) {
    <p class="link-title" (click)="navigateTo(getFormControlByGroupRowAndControlName(type.value, row, 'url').value)"><i
        class="bi bi-link"></i>
        {{getFormControlByGroupRowAndControlName(type.value, row, 'title').value}}
    </p>
  }

    @if(editMode) {
      <div class="row" [formGroup]="getFormControlByGroupRowAndControlName(type.value, row)">
        <div class="col-1 pt-4"><i class="bi bi-link"></i></div>
        <div class="col-5">
          <app-input-form-field
            formControlName="title" [placeholder]="'placeholders.type_title'"
            [label]="'label.title' | translate"
            [errorText]="errors[type.value + row + 'title']"
            [translatable]="false"
            (onChangeEvent)="onInputChange(type.value, row)"
          ></app-input-form-field>
        </div>
        <div class="col-6">
          <app-input-form-field
            formControlName="url"
            [placeholder]="'placeholders.type_url'"
            [label]="'label.url' | translate"
            [errorText]="errors[type.value + row + 'url']"
            [translatable]="false"
            (onChangeEvent)="onInputChange(type.value, row)"
          ></app-input-form-field>
        </div>
      </div>
    }
  }
</div>
}
